import { useEffect, useRef } from 'react';
import { loadCloudLink, onCloudLinkChanged } from '@/lib/cloud-link';
import type { DesktopShellStore } from '@/lib/desktop-shell/store';

/**
 * A conversation on the cloud cannot stay open once the cloud is unlinked: its routes are no
 * longer relayed there, so the session starts a new conversation.
 */
export function useLeaveUnlinkedCloud(store: DesktopShellStore, resetConversation: () => void) {
  const resetRef = useRef(resetConversation);
  resetRef.current = resetConversation;
  useEffect(
    () =>
      onCloudLinkChanged(() => {
        const { chatId, syncedThreads, remoteExecutionTarget } = store.getState();
        const onCloud =
          remoteExecutionTarget?.cloud === true ||
          syncedThreads.some((thread) => thread.id === chatId && thread.onCloud === true);
        if (!onCloud) return;
        void loadCloudLink()
          .then((status) => {
            if (status.account === null) resetRef.current();
          })
          .catch(() => undefined);
      }),
    [store],
  );
}
